import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { HealthServiceCard } from '../components/shared/ShireInlineSections';
import { MedicalServices } from '../components/shared/MedicalServices';
import { PharmacyServices } from '../components/shared/PharmacyServices';

export const Route = createFileRoute('/shire/$name_/health')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Health',
      'Local hospital, GPs, pharmacies and dental services for this shire.',
    ),
  component: HealthPage,
});

function HealthPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Health"
      title="Health services"
      lede={`Hospital, GPs, pharmacies and dental options across the Shire of ${shire.name}.`}
    >
      <HealthServiceCard shire={shire} />
      <MedicalServices shireId={shire.id} />
      <PharmacyServices shireId={shire.id} />
    </ShireSubPageShell>
  );
}
